let currentLanguageHandler: (() => string) | null = null;

const NativeLanguageMap: Record<string, string> = {
  zh: 'zh',
  'zh-CN': 'zh',
  'zh-TW': 'zh-Hant',
  'zh-Hans': 'zh',
  zh_Hans: 'zh',
  'zh-Hant': 'zh-Hant',
  zh_Hant: 'zh-Hant',
  id: 'id',
  in: 'id',
  ms: 'ms',
  my: 'ms',
  th: 'th',
  vi: 'vi',
  fil: 'tl',
  tl: 'tl',
  es: 'es',
  ja: 'ja',
  pt: 'pt',
  pt_PT: 'pt',
  'pt-PT': 'pt',
  ko: 'ko',
  de: 'de',
  fr: 'fr',
  hi: 'hi',
  ru: 'ru',
  ar: 'ar',
  tr: 'tr'
};

/**
 * registerLanguageHandler is global function to register language handler.
 * @param handler a function that returns the original language string.
 */
export const registerLanguageHandler = (handler: () => string): void => {
  currentLanguageHandler = handler;
};

/**
 * getDetectedLanguage is global function to get detected and normalized language.
 * @returns normalized language code (e.g. "en", "zh", "zh-Hant"), default to "en" if not registered or error occurs.
 */
export const getDetectedLanguage = (): string => {
  if (typeof currentLanguageHandler !== 'function') {
    console.warn("Language handler is not registered or is not a function. Defaulting to 'en'.");
    return 'en';
  }

  try {
    const rawLanguage = currentLanguageHandler();
    const normalizedLanguage = NativeLanguageMap[rawLanguage] ?? 'en';
    return normalizedLanguage;
  } catch (error) {
    console.error('Error executing registered language handler:', error);
    return 'en';
  }
};
